import { createFetcher } from '../../Common';

import { getBaseUrl, TEMPLATES_ENDPOINT_API } from '../../constants';

export class Templates {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Templates(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = TEMPLATES_ENDPOINT_API;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllTemplates() {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.getData(url);

    if (response?.data) {
      const reversedData = [...response.data].reverse();

      return { data: reversedData, meta: response?.meta };
    }
    return { data: [], meta: response?.meta };
  }

  async getTemplateById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async putTemplateById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, req.reqBody);
    return response?.data;
  }

  async postTemplate(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async deleteTemplateById(reqId) {
    const url = `${this.base_url + this.endpoint}/${reqId}`;
    const response = await this.fetcher.deleteData(url);
    return response;
  }

  async generateOfferLetter(req) {
    const url = `${this.base_url}/generate-offer-letter`;
    const response = await this.fetcher.postData(url, req);
    return response?.data;
  }

  // based upon where it is called this will change
  async getPlaceholders(type = 'REJECT') {
    const url = `${this.base_url}/placeholders/${type}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }
}

export const createTemplates = () => Templates.getInstance();
